/* Departure board and field-note links.
   - The whole departure row is clickable, not only the destination name.
   - Links that open a field note tab (board rows, trip finder) land on that note's tabs,
     just under the sticky header, instead of the top of the Field notes section.
   - On other pages, links to homepage-only sections go to the homepage.
   - Header dropdown menus, and ?trip= links that tick countries in the trip sketch. */
(function () {
  'use strict';
  var doc = document;

  function noMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  function headerOffset() {
    var h = doc.querySelector('.up-header');
    var px = h ? h.getBoundingClientRect().height : parseFloat(getComputedStyle(doc.documentElement).getPropertyValue('--up-header-h')) || 76;
    return px + 16;
  }

  function bootRows(scope) {
    Array.prototype.forEach.call((scope || doc).querySelectorAll('.up-board__row'), function (row) {
      var link = row.querySelector('.up-board__link');
      if (!link || row.hasAttribute('data-up-rowlink')) return;
      row.setAttribute('data-up-rowlink', '');
      row.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        link.click();
      });
    });
  }

  doc.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-up-tab]');
    if (!link || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var section = doc.getElementById(href.slice(1));
    if (!section || !section.matches('[data-up-init="destinations"]')) return;
    e.preventDefault();
    var tab = section.querySelector('[data-up-tab-key="' + link.getAttribute('data-up-tab') + '"]');
    var target = (tab && tab.closest('[role="tablist"]')) || section;
    window.requestAnimationFrame(function () {
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: noMotion() ? 'auto' : 'smooth' });
    });
    if (window.history && history.pushState && location.hash !== href) history.pushState(null, '', href);
  });

  /* On trip pages and field notes, "#section" links that point at a homepage-only section go to the homepage. */
  function fixHashLinks(scope) {
    var path = window.location.pathname;
    if (path === '/' || path === '') return;
    Array.prototype.forEach.call((scope || doc).querySelectorAll('a[href^="#"]'), function (a) {
      var id = a.getAttribute('href').slice(1);
      if (id && !doc.getElementById(id)) a.setAttribute('href', '/#' + id);
    });
  }

  /* Header dropdowns: open on hover (with a short close delay), keyboard focus or tap; Escape closes. */
  function desk() { return !!(window.matchMedia && window.matchMedia('(min-width: 990px)').matches); }
  function canHover() { return !!(window.matchMedia && window.matchMedia('(hover: hover)').matches); }
  function bootMenus(scope) {
    var items = Array.prototype.slice.call((scope || doc).querySelectorAll('[data-up-dd]'));
    items.forEach(function (li) {
      if (li._upDd) return;
      li._upDd = true;
      var link = li.querySelector('.up-nav__link');
      var btn = li.querySelector('.up-nav__toggle');
      var timer;
      function set(open) {
        if (open) items.forEach(function (o) { if (o !== li && o._upSet) o._upSet(false); });
        if (open) li.setAttribute('data-open', ''); else li.removeAttribute('data-open');
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      li._upSet = set;
      li.addEventListener('mouseenter', function () { if (!desk() || !canHover()) return; clearTimeout(timer); set(true); });
      li.addEventListener('mouseleave', function () { if (!desk() || !canHover()) return; timer = setTimeout(function () { set(false); }, 180); });
      li.addEventListener('focusout', function (e) { if (desk() && !li.contains(e.relatedTarget)) set(false); });
      if (btn) btn.addEventListener('click', function () { set(!li.hasAttribute('data-open')); });
      if (link) link.addEventListener('click', function (e) {
        if (desk() && !canHover() && !li.hasAttribute('data-open')) { e.preventDefault(); set(true); return; }
        set(false);
        if (canHover()) link.blur();
      });
      li.addEventListener('click', function (e) { if (e.target.closest('.up-dd__row, .up-dd__all')) set(false); });
    });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-up-dd][data-open]'), function (li) { if (li._upSet) li._upSet(false); });
  });
  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-up-dd]')) return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-up-dd][data-open]'), function (li) { if (desk() && li._upSet) li._upSet(false); });
  });

  /* ?trip=Bali on the personalised trips page ticks those countries in the trip sketch. */
  function prefillFromUrl() {
    var m = window.location.search.match(/[?&]trip=([^&#]+)/);
    if (!m) return;
    var value = decodeURIComponent(m[1].replace(/\+/g, ' '));
    var tries = 0;
    (function attempt() {
      var done = false;
      Array.prototype.forEach.call(doc.querySelectorAll('[data-up-init="planner"]'), function (s) { if (s.upPrefill) { s.upPrefill(value); done = true; } });
      if (!done && tries++ < 20) setTimeout(attempt, 150);
    })();
  }

  /* Plan a trip: sends the sketch, name, email and phone to the store contact email. */
  var PLAN_FIELDS = [
    ['name', 'Your name', 'text', 'name', true, 'up-field up-field--half'],
    ['email', 'Email', 'email', 'email', true, 'up-field up-field--half'],
    ['phone', 'Phone (optional)', 'tel', 'tel', false, 'up-field']
  ];
  function bootPlanForms(scope) {
    Array.prototype.forEach.call((scope || doc).querySelectorAll('form[data-up-form]'), function (form, n) {
      if (form._upMail) return;
      form._upMail = true;
      if (!form.id) form.id = 'UpTripContact-' + n;
      form.setAttribute('data-shopify-captcha', 'true');
      form.setAttribute('method', 'post');
      form.setAttribute('action', '/contact');
      form.setAttribute('accept-charset', 'UTF-8');
      var actions = form.querySelector('.up-form__actions');
      var num = form.querySelectorAll('.up-field__num').length;
      var html = '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[Enquiry]" value="Plan a trip"><textarea name="contact[body]" hidden></textarea>';
      PLAN_FIELDS.forEach(function (f) {
        var id = 'UpPlan-' + f[0] + '-' + n;
        num += 1;
        html += '<div class="' + f[5] + '"><label class="up-field__label" for="' + id + '"><span class="up-field__num">' + (num < 10 ? '0' : '') + num + '</span>' + f[1] + '</label>' +
          '<input class="up-textarea" id="' + id + '" type="' + f[2] + '" name="contact[' + f[0] + ']" autocomplete="' + f[3] + '" maxlength="120" style="min-height:0;height:3.25rem;resize:none"' + (f[4] ? ' required' : '') + '></div>';
      });
      var box = doc.createElement('div');
      box.style.display = 'contents';
      box.innerHTML = html;
      form.insertBefore(box, actions || null);
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) window.Shopify.captcha.protect(form);
      var send = form.querySelector('[type="submit"]');
      if (send && send.firstChild && send.firstChild.nodeType === 3) send.firstChild.nodeValue = 'Send my trip sketch ';
      var walk = doc.createTreeWalker(form.closest('section') || form, NodeFilter.SHOW_TEXT, null), t;
      while ((t = walk.nextNode())) {
        if (/nothing (is|has been|gets) sent/i.test(t.nodeValue)) t.nodeValue = /preview/i.test(t.nodeValue) ? 'Sent straight to the Unpinned team. We reply by email.' : 'Your trip sketch. Send it and we’ll reply by email.';
      }
      if (/[?&]contact_posted=true/.test(window.location.search)) {
        var ok = doc.createElement('p');
        ok.setAttribute('role', 'status');
        ok.style.cssText = 'margin:0 0 1rem;padding:1rem 1.1rem;border:1px dashed currentColor;font-weight:500';
        ok.textContent = 'Thanks, your trip sketch is with us. We’ll reply by email.';
        form.insertBefore(ok, actions || null);
        if (n === 0) setTimeout(function () { ok.scrollIntoView({ block: 'center' }); }, 300);
      }
    });
  }
  function sketchText(form) {
    var map = {}, order = [];
    new FormData(form).forEach(function (v, k) {
      v = String(v).trim();
      if (!v || !/^(who|size|where|when|length|pace|interests|comfort|notes)$/.test(k)) return;
      if (!map[k]) { map[k] = []; order.push(k); }
      map[k].push(v);
    });
    return order.map(function (k) {
      var f = form.querySelector('[name="' + k + '"]');
      var box = f && f.closest('fieldset, .up-field');
      var lab = box && box.querySelector('.up-field__label');
      return (lab ? lab.textContent.replace(/^\s*\d+\s*/, '').trim() : k) + ': ' + map[k].join(', ');
    }).join('\n');
  }
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form._upMail) return;
    if (form.reportValidity && !form.reportValidity()) { e.preventDefault(); return; }
    var body = form.querySelector('[name="contact[body]"]');
    var section = form.closest('section');
    var ticket = section && section.querySelector('[data-up-brief]');
    if (body) body.value = 'Personalised trip request from ' + window.location.pathname + '\n\n' + sketchText(form) + (ticket ? '\n\nTRIP NOTE AS SHOWN\n' + ticket.innerText.trim() : '');
  }, true);

  function boot() { bootRows(); fixHashLinks(); bootMenus(); prefillFromUrl(); bootPlanForms(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  doc.addEventListener('shopify:section:load', function (e) { bootRows(e.target); bootMenus(e.target); bootPlanForms(e.target); });
})();
